import * as React from 'react';
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Select,
  Typography
} from '@mui/material';
import { gray100, gray90, primaryColor, red100 } from '../../constants/Colors';
import { formLabelWrapper } from '../../constants/Location';
import type { FieldError } from 'react-hook-form';

type selectProps = React.ComponentProps<typeof Select>;
export interface List {
  value: number;
  option: string;
  disabled?: boolean;
}
type Props = selectProps & {
  labelText?: string;
  requiredText?: string;
  error?: boolean;
  helperText?: string | FieldError | undefined;
  width?: string;
  list: List[];
  value: boolean[];
  onChange: (selected: boolean[]) => void;
};

const CustomCheckBox = React.forwardRef<HTMLDivElement, Props>(
  (props: Props, ref): React.ReactElement => {
    const {
      labelText,
      requiredText,
      error,
      helperText,
      list,
      value,
      onChange
    } = props;

    const styles = {
      formLabelWrapper,
      label: {
        color: gray100,
        fontSize: '14px'
      },
      required: {
        color: red100,
        fontSize: '12px',
        marginLeft: '10px'
      }
    };

    const handleChange = (
      optionValue: number,
      event: React.ChangeEvent<HTMLInputElement>
    ) => {
      const newValue = [...value];
      newValue[optionValue] = event.target.checked;
      onChange(newValue);
    };

    const textfieldHelper = (): string | undefined => {
      if (helperText === undefined) return;
      return String(helperText);
    };

    return (
      <Typography align="left" component="div">
        <Typography align="left" sx={styles.formLabelWrapper} component="div">
          <Typography sx={styles.label} component="span">
            {labelText}
          </Typography>
          {requiredText && (
            <Typography component="span" sx={styles.required}>
              {requiredText}
            </Typography>
          )}
        </Typography>
        <Typography sx={{ textAlign: 'left' }} component="div">
          <FormGroup sx={{ width: props.width || '100%' }}>
            {list.map((item, index) => (
              <FormControlLabel
                key={index}
                control={
                  <Checkbox
                    sx={{
                      '&.Mui-checked': {
                        color: primaryColor
                      },
                      color: gray90
                    }}
                    checked={value[index]}
                    onChange={(event) => handleChange(index, event)}
                  />
                }
                label={item.option}
                value={item.value}
                ref={ref}
                sx={{ color: gray100 }}
              />
            ))}
          </FormGroup>
        </Typography>
        <FormHelperText error={error}>{textfieldHelper()}</FormHelperText>
      </Typography>
    );
  }
);
export default CustomCheckBox;
